import { useShowPrompt } from 'civic-champs-shared/core/modal/hooks'
import OrganizationDataModal from 'organization/component/OrganizationDataModal'
import { useCallback } from 'react'
import { currentOrgUpdated } from 'auth/actions'
import { useCurrentOrg } from 'auth/hooks'
import useCreateOrUpdateOrganization from 'volunteering/organizations/hooks/useCreateOrUpdateOrganization'
import { useDispatch } from 'react-redux'
import { useCreateApiNotification } from 'civic-champs-shared/api/hooks'
import { mapOrgToPayload } from '../helpers'
import { Organization } from 'organization/types'

export const useShowOrganizationEdit = (
  org?: Organization,
  handleDispatchOrganization?: (value: Organization) => void,
) => {
  const showEditOrgData = useShowPrompt(OrganizationDataModal)
  const currentOrg = useCurrentOrg()
  const organization = org ?? currentOrg
  const createOrUpdateOrganization = useCreateOrUpdateOrganization()
  const dispatch = useDispatch()
  const createNotification = useCreateApiNotification()
  return useCallback(async () => {
    const { name, website, timeZone } = await showEditOrgData({ organization: organization })
    const notification = createNotification(`Saving Organization`)
    try {
      const updatedOrg = await createOrUpdateOrganization(
        { ...mapOrgToPayload(organization), name, website, timeZone: timeZone.value },
        organization.id,
      )
      if (!handleDispatchOrganization) {
        if (organization.id === currentOrg.id) {
          dispatch(currentOrgUpdated(updatedOrg))
        }
      } else {
        handleDispatchOrganization(updatedOrg)
      }
      notification.onSuccess('Organization saved successfully')
    } catch (e) {
      notification.onError('Failed to save organization', e)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organization])
}
